import { DepositNetwork, GetAllCoinType, MarketPriceBySymbol, NetworksTypes } from 'interfaces';
import { __TypeOfOrderEnum } from './initial/initial.interface';
import { __BuyPaymentMethodsEnum } from './buyPaymentMethod/buyPaymentMethod.interface';
import { __SellWithdrawMethodsEnums } from './sellWithdrawMethod/sellWithdrawMethod.interface';

export enum __ConvertBoxStatesEnum {
    Initial,
    BuySelectCard,
    BuyWithdrawMethod,
    BuyPaymentMethod,
    SellWithdrawMethod,
    SellDeposit,
    SellCryptoTxId,
    EnterPayeerAccount
}

export interface __ConvertBoxDataType {
    srcCoin?: GetAllCoinType;
    srcValue?: number;
    srcPrice?: MarketPriceBySymbol;
    destCoin?: GetAllCoinType;
    destValue?: number;
    destPrice?: MarketPriceBySymbol;
    typeOfOrder?: __TypeOfOrderEnum;
    walletAddress?: string;
    network?: NetworksTypes | DepositNetwork;
    memoTag?: string;
    bankAccountId?: string;
    fee?: number;
    buyPaymentMethod?: __BuyPaymentMethodsEnum;
    trackingCode?: string;
    withdrawMethod?: __SellWithdrawMethodsEnums;
    destinationAccount?: string;
}

export interface __ConvertBoxProps {
    onChangeState?: (e: __ConvertBoxStatesEnum) => void;
    isPreview?: boolean;
    title?: string;
    onFinish?: () => void;
}
